import React from 'react'
import ReactDOM from 'react-dom'
// 通用的样式
import 'antd/dist/antd.css'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
